import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const createFormulaSetVersionDto = z.object({
  formulaSetId: z.string(),
  version: z.number().int(),
  script: z.string(),
});

export class CreateFormulaSetVersionDto extends createZodDto(
  createFormulaSetVersionDto,
) {}
